module.exports = __webpack_public_path__ + "img/11.931f42f8.png";